(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aq-pure-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-maintenance-animation]').forEach(stage => {
  const image = stage.querySelector('[data-animation-image]');
  const button = stage.querySelector('[data-animation-toggle]');
  if (!image || !button || !image.dataset.animationPoster) return;
  let playing = true;
  const render = () => {
    image.src = playing ? image.dataset.animationSrc : image.dataset.animationPoster;
    button.textContent = playing ? 'Ferma animazione' : 'Riproduci animazione';
    button.setAttribute('aria-pressed', String(playing));
  };
  button.addEventListener('click', () => { playing = !playing; render(); });
  render();
});
  } catch(e) { console.error(e); }
})();

})();
